// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__BM1pd","linkStack":"Navbar_linkStack__k9Nih","normal":"Navbar_normal__vg5XA","hamburger":"Navbar_hamburger__UTIAN","item":"Navbar_item__u2rm8"};